import { Box, Flex, FlexProps, Text } from "@chakra-ui/react";
import { kinds, NostrEvent } from "nostr-tools";
import { ReactNode, useState } from "react";

import useEventIntersectionRef from "../../hooks/use-event-intersection-ref";
import Timestamp from "../timestamp";

export type MessageProps = Omit<FlexProps, "children"> & {
  message: NostrEvent;
  showHeader?: boolean;
  isSelf?: boolean;
  renderContent: (message: NostrEvent) => ReactNode;
  renderActions?: (message: NostrEvent, onReply?: (message: NostrEvent) => void) => ReactNode;
};

export default function Message({
  message,
  showHeader = true,
  isSelf = false,
  renderContent,
  renderActions,
  ...props
}: MessageProps) {
  const ref = useEventIntersectionRef(message);
  const [hover, setHover] = useState(false);

  return (
    <Flex
      ref={ref}
      justify={isSelf ? "flex-end" : "flex-start"}
      w="full"
      px="2"
      py="0.5"
      position="relative"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...props}
    >
      {/* Actions float above the bubble */}
      {hover && renderActions && (
        <Box
          position="absolute"
          top="-3"
          {...(isSelf ? { left: "2" } : { right: "2" })}
          borderWidth={1}
          borderRadius="md"
          bg="var(--chakra-colors-chakra-body-bg)"
          px="1"
          py="0.5"
          zIndex={1}
        >
          {renderActions(message)}
        </Box>
      )}

      <Box
        maxW="75%"
        bg={isSelf ? "primary.500" : "whiteAlpha.100"}
        color={isSelf ? "white" : undefined}
        borderRadius="xl"
        borderBottomRightRadius={isSelf ? "sm" : "xl"}
        borderBottomLeftRadius={isSelf ? "xl" : "sm"}
        px="3"
        py="1.5"
        position="relative"
      >
        {renderContent(message)}
        <Flex justify="flex-end" mt="0.5">
          <Text fontSize="2xs" color={isSelf ? "whiteAlpha.700" : "gray.500"} lineHeight="1">
            <Timestamp timestamp={message.created_at} />
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
}
